import { useQuery } from "@tanstack/react-query";
import { getDeveloperSdkAuthInit } from "apis";

const useGetDeveloperAuthInit = () => {
  return useQuery(["developer-auth-init"], () => getDeveloperSdkAuthInit(), {
    staleTime: 1000 * 60 * 15,
  });
};

export default useGetDeveloperAuthInit;
